/**
 * header-slider.js
 * -----------------
 * Initialise the hero carousel on `.page-header-sliders` using Slick.
 * Mirrors the behaviour defined in `components/PageHeaderSliders.vue`.
 *
 * Dependencies (expected to be loaded globally before this script):
 *   – jQuery (window.jQuery / $)
 *   – Slick carousel plugin (`slick.min.js`)
 */

(function ($) {
  'use strict';

  /**
   * Bootstraps Slick on the page-header slider if present and not yet initialised.
   */
  function initHeaderSlider() {
    const $slider = $('.page-header-sliders__slick');

    // Abort if slider element or Slick is unavailable.
    if (!$slider.length || typeof $.fn.slick === 'undefined') return;

    // Prevent double initialisation.
    if ($slider.hasClass('slick-initialized')) return;

    $slider.slick({
      // Core behaviour (matches <PageHeaderSliders.vue>)
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 7000, // 7 seconds
      pauseOnHover: false,

      // Accessibility & interaction tweaks
      pauseOnFocus: false,
      accessibility: true,

      // Layout
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,

      // Styling hooks
      prevArrow:
        '<button type="button" class="slick-prev" aria-label="Previous">Previous</button>',
      nextArrow:
        '<button type="button" class="slick-next" aria-label="Next">Next</button>',
      customPaging () {
        // Keep dots consistent with existing SCSS styles
        return '<div class="custom-dot"></div>';
      },
    });
  }

  // Initialise once DOM is ready.
  $(document).ready(initHeaderSlider);
})(window.jQuery); 